export class PedigreeDrawingData {
	constructor() {
		this.clickMap = new Map();
		this.selected_id_list = new Set();
    	this.is_selection_box_dragging = false;
		this.subtext_left_per_node = new Map();
	}

  getIsSelectionBoxDragging() {
    return this.is_selection_box_dragging;
  }
  setIsSelectionBoxDragging(is_dragging) {
    this.is_selection_box_dragging = is_dragging;
  }

	set_selected_id_list(id_list) {
		this.selected_id_list.clear();
		for (const element of id_list) {
			this.selected_id_list.add(element);
		}
	}
	getSelectedCount() {
		return this.selected_id_list.size;
	}
  getSelectedList() {
    return [...this.selected_id_list];
  }
	assign_click_count(node_id, count) {
		this.clickMap.set(node_id, count);
	}
	assign_subtext_left(node_id, left) {
		this.subtext_left_per_node.set(node_id, left);
	}
	get_subtext_left(node_id) {
		if (this.subtext_left_per_node.has(node_id)) {
			return this.subtext_left_per_node.get(node_id);
		}
		return undefined;
	}
	click_node(node_id, increment = 1) {
		// let count = 0;
		// if (this.clickMap.has(node_id)) {
		// 	count = this.clickMap.get(node_id);
		// }
		// count = Math.min(count + increment, 2);
		// this.clickMap.clear();
		// this.clickMap.set(node_id, count);
		// console.log(this.clickMap)
		// return count;
		let count = 0;
		if (this.clickMap.has(node_id)) {
			count = this.clickMap.get(node_id);
		}
		count += increment;
		this.clickMap.clear();
		this.clickMap.set(node_id, count);
		if (count > 2){
			this.clickMap.set(node_id, 1);
		}
		return count;

		// this.clickMap.set(node_id, count);
		// console.log(this.clickMap)
		// return count;
		// node.data = {
		// 	...node.data,
		// 	nodeClickCount: node.data.nodeClickCount + 1,
		// };
		// if (node.data.nodeClickCount > 2) {

		// }
	}
	clear_click_count_for_node(node_id) {
		this.clickMap.delete(node_id);
	}
	clear_click_count() {
		this.clickMap.clear();
	}
	getClickCount(node_id) {
		let count = 0;
		if (this.clickMap.has(node_id)) {
			count = this.clickMap.get(node_id);
		}
		return count;
	}
}
